<template>
  <div v-if="shippingOptions.length >= 1" class="col-12 col-lg-6 d-flex flex-column p-3">
    <OperationsTitle name="Shipping" />
    <OperationOption
      v-for="shippingOption in shippingOptions"
      :key="shippingOption.type"
      :title="shippingOption.title"
      :subtitle="shippingOption.subtitle"
      :icon-class="shippingOption.iconClass"
    />
  </div>
</template>

<script>
import OperationsTitle from "../common/OperationsTitle.vue";
import OperationOption from "../common/OperationsOption.vue";
import { currency } from "@/services/filters";

export default {
  name: "OperationsShipping",
  components: {
    OperationsTitle,
    OperationOption,
  },
  props: {
    operation: { type: Object, requried: true },
  },
  computed: {
    shippingOptions() {
      return Object.keys(this.operation).reduce((result, operationKey) => {
        const operationValue = this.operation[operationKey];
        const shippingOption = {
          type: operationKey,
          title: operationKey,
          subtitle: undefined,
          iconClass: "far fa-check-circle",
        };
        if (operationKey === "shipping_free" && operationValue) {
          shippingOption.title = `Free Over ${this.currency(this.operation.shipping_free_value)}`;
          shippingOption.subtitle = `Within ${this.operation.shipping_free_distance} miles of Operation`;
          result.push(shippingOption);
        }
        if (operationKey === "shipping_pickup" && operationValue) {
          shippingOption.title = "Pickup at Location";
          result.push(shippingOption);
        }
        return result;
      }, []);
    },
  },
  methods: {
    currency,
  },
};
</script>

<style scoped></style>
